import api from "api/api";
import { cleanUrl } from "utils/helper";

const fetchStatisticsQuery = async ({
  type,
  scope,
  signed_by,
  date,
  charged_by,
  mission_type,
  client,
}) => {
  const queryString = cleanUrl({
    scope,
    date,
    mission_signed_by: signed_by,
    mission_charged_by: charged_by,
    mission_type,
    client,
  });
  return await api.get(`/dashboard/${type}/statistics?${queryString}`);
};

export const fetchIcStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "ic" });

export const fetchEdStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "ed" });

export const fetchClStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "cl" });

export const fetchMissionStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "mission" });

export const fetchBillingStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "billing" });

export const fetchFaeStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "fae" });

export const fetchRatioStatistics = async (params) =>
  fetchStatisticsQuery({ ...params, type: "ratio" });
